import React from 'react';
import { withAuth } from '../../../providers/AuthProvider';
import wait from '../../../../static/img/backgrounds/waiting.png'

const LogoutPage = () => {
    return (
        <div className="redirect">
            <div className="container">
                <div className="row">
                    <div className="col-lg-7 col-md-7">
                        <div className="image-wrapper">
                            <img src={wait} />
                        </div>
                    </div>
                    <div className="col-lg-5 col-md-5 loading-outter-container">
                        <div className="loading">
                            <svg className="spinner" viewBox="0 0 50 50">
                                <circle className="path" cx="25" cy="25" r="20" fill="none" strokeWidth="5"></circle>
                            </svg>
                        </div>
                        <span>
                            <h2>Logging out</h2>
                            <p>Please wait. You'll be redirected to our landing page!</p>
                        </span>
                    </div>
                </div>
            </div>
        </div>
    )
}

const LogoutWrapper = ({ children, auth }) => {
    if (auth && auth.isSigningOut) {
        return <LogoutPage />
    }
    else {
        return children
    }
}

export default withAuth(LogoutWrapper) 
